export default __webpack_public_path__ + "20f46f92045a27ec3e377b18e4c624a4.jpg";